import api from '../../api/auth'

const app = new Vue({
  i18n,
	el: '#authLogout',
  data: () => ({

  }),
	mounted () {
    this.onSubmit()
	},
	methods: {

    onSubmit () {
      window.Cookies.remove('utoken')
      api.logout(
        (response) => {
          // console.log('xxxxx', response)
          location.href = `/`
        },
        (error) => {
          console.log(error)
          location.href = `/`
        }
      )
    }

		// onSubmit (e) {

		// 	this.$validator.validateAll().then((result) => {
		// 		if(result) {
		// 			this.isSubmitting = true
		// 			// e.preventDefault()

		// 			const data = {
		// 				username: this.username,
		// 				password: this.password,
		// 				securityCode: this.securityCode,
    //       }


    //       api.login(data,
    //         (response) => {
    //           // console.log(response)
    //           this.isSubmitting = false
    //           const data = _.get(response.data, 'data')

    //           window.Cookies.set('utoken', JSON.stringify(data), {
    //             expires: 1,
    //             path: '/'
    //           })
    //           location.href = `/${data.role}`
    //         },
    //         (error) => {
    //           // console.log(error)
    //           this.isSubmitting = false
    //           // this.handleErrorMessage(error)
    //           this.alertErrorMessage(error, '#authLogin')
    //         }
    //       )
		// 		}
		// 	})
		// },
	}
})
